export default "__VITE_ASSET__DXOeoE2m__"